import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IntegrationsHttpClient } from '@recruitee/integrations-http';

import { IntegrationAbilitiesActions } from './integration-abilities.store';

@Injectable({ providedIn: 'root' })
export class IntegrationAbilitiesEffects {
  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IntegrationAbilitiesActions.fetch),
      switchMap(({ payload: { kinds } }) =>
        this.integrationsHttpClient.loadIntegrationAbilities(kinds).pipe(
          map(kinds => IntegrationAbilitiesActions.fetchSuccess({ payload: kinds })),
          catchError((error: HttpErrorResponse) =>
            of(IntegrationAbilitiesActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private integrationsHttpClient: IntegrationsHttpClient,
  ) {}
}
